import appSettings from '../../../components/Infrastructure/Settings/AppSettings';

export const webserverServiceProUrl: string = `${appSettings.getBaseUrl()}webserver-service-pro`;
